import React from 'react'
import CallUs from '../components/Callus'
import { Navbar } from '../components/navbar'
import { SectionTitle } from '../components/sectionTitile'
import styled from 'styled-components'
import Btn from '../components/button'
import Navigation from '../navigation'
import { scroller } from 'react-scroll'
import { NavLink } from 'react-router-dom'
import Header from '../header'
import themes from '../themes'
import WebBackground from '../Logos/backgronds/top-developers.png'
import { Marginer } from '../components/marginer'
import ResponsiveImage from '../tools/pictures/responsive-design-ss-1.png'
import PrinciplesImage from '../tools/pictures/20-web-design-principles-to-follow-featured-image.png'
import { Footer } from '../components/footer'



const SectionStyle = styled(SectionTitle)`
text-align:center;
padding:1rem;
`;

const FooterStyle = styled(Footer)`
background-color:${themes.white};
color:${themes.white};
`

const Background = styled.div`
width:100%;
height:100vh;
background-image:url(${WebBackground});

`;

const ResponsiveImg = styled.img`
width:50%;


@media(max-width:680px){
       width:100%;
}
`;
const NavigationStyle = styled(Navigation)`
margin-top:3rem;


@media screen and (max-width:780px){
       margin-top:0rem;
};
`

const BackgroundFilter = styled.div`
width:100%;
height:100vh;
background-size:cover;
background-color:rgba(55,55,55,0.89);
background-repeat:no-repeat;
opacity:0.8;
`;


const HeaderStyle = styled(Header)`
color:${themes.white};
`;

const Container = styled.div`
background-color:${themes.white};
`

const InnerContainer = styled.div`
display:flex;
flex-direction:row;
justify-content:center;
align-items:center;
padding:1rem;

@media(max-width:680px){
       display:flex;
       flex-direction:column;
}
`

const Paragraph = styled.p`
padding:1rem;
color:${themes.primary};
width:50%;
line-height:2.0;


@media (max-width:680px){
       width:100%;
}
`



function WebDesign(){

        const scrollToContactUs = () =>{
   scroller.scrollTo("contactus", {smooth: true, duration:"1000"})
  }

       
    return(
 <div>
        <Navbar />
        <CallUs />  
        <Background>
               <BackgroundFilter>
                      <Marginer direction="vertical" margin="2rem"/>
        <HeaderStyle>We are fond of Creating websites</HeaderStyle>
        <p style={{padding:"1rem",lineHeight:"2.0",color:"#ffffff"}}>
               Talking about website design, there are host of website design companys out-there that offers website design services.
               What makes us stand out as the best website design and development company is that we are not only concerned about the appearance of your websites but we also make sure that
               users easily get what they are looking for on your website.
               We help you take care of the appearance, layout and content of the website.
       </p>

       <NavigationStyle>
              <NavLink to="/contacts"> Contact us </NavLink> </NavigationStyle>
        </BackgroundFilter>
        </Background>

        <Container>
       <Marginer direction="vertical" margin="2rem"/>
        <HeaderStyle style={{color:"#000080"}}>Responsive Web Design</HeaderStyle>
        <InnerContainer>
        <ResponsiveImg src={ResponsiveImage} />
        <Paragraph>
              In today's world of mobile phone,where most of the websites is accesessed from mobile,the need to make the website fit for any device on which it's accessed 
              is inevitable and vital. That is why at <b>Tecspot</b>, we have teams of professional web designers who are experts in making sure that all the websites that's being created is 
              soothened to every device from which it is accessed. From smart phones to ipads to notebooks ,windows and all device categories.
       </Paragraph>
       </InnerContainer>
       <Marginer direction="vertical" margin="2rem"/>

        <HeaderStyle style={{color:"#000080"}}>Web Design Principles</HeaderStyle>
        <InnerContainer>
        <Paragraph>
              For a website to be user friendly and soothened to the taste of the users, designers must follow all the necessary recipe needed for a website to be fit for use.
              We take cognizance of all the principles necessary to ensure that your website is delivered to your taste
       </Paragraph>
       <ResponsiveImg src={PrinciplesImage}/>

       
       </InnerContainer>
       </Container>   
       <FooterStyle/>        
      
              
 </div>
          )
}

export default WebDesign